import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid2';
import { Box, Button, Link, ListItem, ListItemAvatar, ListItemText, Typography} from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AssessmentIcon from '@mui/icons-material/Assessment';

const forms = [
    {
      title: 'Organization Form CPF M 101',
      subtitle:
        'Statement of Organization Form for candidates and committees to register with local election officials',
      icon: (
        <AccountBalanceIcon fontSize="large" />
      ),
      link: 'https://ocpf2.blob.core.windows.net/pdf/forms/cpf_m101.pdf'
    },
    {
      title: 'Not Raising or Expending Campaign Funds Form CPF M 109',
      subtitle:
        "Form filled out by the candidate who has not received any contributions or made any expenditures",
      icon: (
        <AttachMoneyIcon fontSize="large" />
      ),
      link: 'https://ocpf2.blob.core.windows.net/pdf/forms/CPFM109.pdf'
    },
    {
      title: 'Municipal Campaign Finance Report Form CPF M 102',
      subtitle:
        'This form is used when filing reports with local election authorities such as town or city clerks. The M102 is the standard disclosure form.',
      icon: (
        <AssessmentIcon fontSize="large" />
      ),
      link: 'https://ocpf2.blob.core.windows.net/pdf/forms/M102_edit.pdf'
    },
  ];

const FeaturedForms = (): JSX.Element => {
    return (
    <Box marginTop={3} marginBottom={4}>
        <Box marginBottom={4}>
        <Typography
          variant="h6"
          sx={{
            textTransform: 'uppercase',
          }}
          fontWeight={700}
          data-aos={'fade-up'}
          gutterBottom
          color={'secondary'}
          align={'center'}
        >
          Frequently Requested Forms for Municipal Candidates
        </Typography>
      </Box>
      <Grid container spacing={4}>
        {forms.map((item, i) => (
          <Grid key={i} size={{xs:12, md:4}}>
            <ListItem
              component={Link}
              href={item.link}
              target={'_blank'}
              disableGutters
              className='is-clickable'
              data-aos={'fade-up'}
              data-aos-delay={i * 100}
              data-aos-offset={100}
              data-aos-duration={600}
              sx={{
                flexDirection: 'column',
                alignItems: 'center',
                padding: 0,
              }}
            >
              <Box
                component={ListItemAvatar}
                marginBottom={1}
                minWidth={'auto !important'}
              >
                <Box color={'primary.ocpfBlue'}>{item.icon}</Box>
              </Box>
              <ListItemText
                primary={item.title}
                secondary={item.subtitle}
                primaryTypographyProps={{
                  variant: 'h6',
                  gutterBottom: true,
                  align: 'center',
                }}
                secondaryTypographyProps={{ align: 'center' }}
                sx={{
                  '& .MuiListItemText-primary': {
                    fontWeight: 700,
                  },
                  margin: 0,
                }}
              />
            </ListItem>
          </Grid>
        ))}
      </Grid>
        <Box marginTop={3} display={'flex'} justifyContent={'center'}>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              component={Link}
              data-aos={'fade-up'}
              href='/Publications/Forms?search=municipal'
            >
              View All Municipal Forms
            </Button>
        </Box>
    </Box>
    )

}

export default FeaturedForms;